import { Component } from '@angular/core';
import { AppConfig } from 'app/app.config';
import { GlobalFunctionsService } from 'app/core/services';

@Component({
  selector: 'fo-error',
  templateUrl: './error.page.html'
})
export class ErrorPage {
  contactEmail: string;
  contactPhone: string;
  contactWebsite: string;
  returnUrl: string;

  constructor(private globalFunctionsService: GlobalFunctionsService, private config: AppConfig) {
    this.contactEmail = this.config.getConfig('contactEmail');
    this.contactPhone = this.config.getConfig('contactPhone');
    this.contactWebsite = this.config.getConfig('contactWebsite');
    this.returnUrl = this.globalFunctionsService.returnUrl || this.config.getConfig('returnUrl') || '/courses';
    this.globalFunctionsService.showBasket(false);
    this.globalFunctionsService.showTabs(false);
  }
}
